import * as actionTypes from "../actionTypes";

export const setLoggedUser = function (payload) {
  return { type: actionTypes.SIGNIN_SUCCEED, payload };
};

export const signOut = function () {
  return { type: actionTypes.SIGNOUT };
};
